import dayjs from "dayjs";

export const dateFormat = (date: any, format = 'MMM DD, YYYY') => {
  return dayjs(date).format(format);
}